/**
 * MultipartUploadService
 * Service for multipart upload operations (large files)
 * Route: api/multipartupload
 */
import { BaseService } from '../base/BaseService';
/**
 * MultipartUploadService
 * Handles multipart upload operations for large files
 */
export class MultipartUploadService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? MultipartUploadService.DEFAULT_SERVICE_PATH,
            basePath: MultipartUploadService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Initiate multipart upload for large file
     * POST api/multipartupload/initiate
     */
    async initiate(data) {
        const response = await this.initiateRaw(data);
        if (!response.data) {
            throw new Error(response.message || 'Failed to initiate multipart upload');
        }
        return response.data;
    }
    /**
     * Initiate multipart upload with full response
     */
    initiateRaw(data) {
        const endpoint = this.getEndpoint('initiate', 'initiate');
        const url = this.buildUrl(endpoint);
        return this.http.post(url, data);
    }
    /**
     * Get presigned URL for uploading a specific part
     * POST api/multipartupload/upload-part
     */
    async getPartUploadUrl(data) {
        const response = await this.getPartUploadUrlRaw(data);
        if (!response.data) {
            throw new Error(response.message || 'Failed to get part upload URL');
        }
        return response.data;
    }
    /**
     * Get part upload URL with full response
     */
    getPartUploadUrlRaw(data) {
        const endpoint = this.getEndpoint('upload-part', 'upload-part');
        const url = this.buildUrl(endpoint);
        return this.http.post(url, data);
    }
    /**
     * Complete multipart upload after all parts are uploaded
     * POST api/multipartupload/complete
     */
    async complete(data) {
        const response = await this.completeRaw(data);
        if (!response.data) {
            throw new Error(response.message || 'Failed to complete multipart upload');
        }
        return response.data;
    }
    /**
     * Complete multipart upload with full response
     */
    completeRaw(data) {
        const endpoint = this.getEndpoint('complete', 'complete');
        const url = this.buildUrl(endpoint);
        return this.http.post(url, data);
    }
    /**
     * Abort multipart upload and clean up resources
     * POST api/multipartupload/abort
     */
    async abort(data) {
        const response = await this.abortRaw(data);
        return response.success;
    }
    /**
     * Abort multipart upload with full response
     */
    abortRaw(data) {
        const endpoint = this.getEndpoint('abort', 'abort');
        const url = this.buildUrl(endpoint);
        return this.http.post(url, data);
    }
}
MultipartUploadService.DEFAULT_SERVICE_PATH = 'files';
MultipartUploadService.BASE_PATH = 'api/multipartupload';
//# sourceMappingURL=MultipartUploadService.js.map